<template>
    <transition appear name="fs-flow-in">
        <div v-if="show" :class="{ simplified: simplified == true }" class="input-page">
            <div class="input-box" ref="input">
                <div class="h1">
                    <div v-show="showError == true" class="error-msg">
                        <h3>Bitte füllen Sie das Feld aus.</h3>
                    </div>
                    <h1>{{label}}</h1> 
                    <template v-if="descr != false">
                        <span class="icon" @mouseenter="showDescr = true" @mouseout="showDescr = false">?
                        <transition name="fs-descr">
                            <span v-if="showDescr" class="description">
                            {{descr}}
                            </span>
                        </transition>
                        </span>
                    </template>
                </div>
                <transition appear name="fs-flow-in-input">
                    <div class="input-wrapper">
                        <template v-if="type == 'textarea'">
                                <textarea class='textarea' :name="name" :value="value" :placeholder="placeholder" @input="$emit('input', $event.target.value)"/>
                        </template>

                        <template v-if="type != 'checkbox' && type != 'radio' && type != 'submit' && type != 'textarea' && type != 'date' && type != 'address'">
                                <input class="input" :type="type" :name="name" :value="value" :placeholder="placeholder" :id="id" @input="$emit('input', $event.target.value)" @keyup.enter="enter">
                        </template>

                        <template v-if="type == 'date'">
                                <input class="input date" type="date" :name="name" :value="value" :placeholder="placeholder" :id="id" @input="$emit('input', $event.target.value)">
                        </template>

                        <template v-if="type == 'address'">
                                <input
                                    class="input"
                                    type="text"
                                    :name="name"
                                    :value="value.name"
                                    :placeholder="placeholder"
                                    :id="id"
                                    v-autocomplete="address"
                                    @keyup.enter="enter"
                                >
                        </template>

                        <template v-if="type == 'submit'">
                                <input :type="type" :name="name" :value="value" :placeholder="placeholder" @input="onInput($event)">
                        </template>

                        <template v-if="type == 'radio'">
                            
                            <label v-for="(displayValue, key) in options" class="checkbox">
                                <input type="radio"
                                    :value="key"
                                    @change="onChange"
                                    v-model="myValue">
                                    <span class="checkbox--wrapper">
                                    {{displayValue}}
                                    </span>
                            </label>
                        </template>

                        <template v-if="type == 'checkbox'">
                            
                            <label v-for="(displayValue, key) in options" class="checkbox">
                                <input type="checkbox"
                                    :value="key"
                                    @change="onChange"
                                    v-model="myValue">
                                    <span class="checkbox--wrapper">
                                    {{displayValue}}
                                    </span>
                            </label>
                        </template>

                        <span class="validation-indicator" :class="{ correct: validated == true }" v-if='validation != false'></span>
                    </div>
                </transition>
            </div>
        </div>
    </transition>
</template>


<script>
    import _ from 'lodash'

    export default {
        props: {
            type: {}, 
            name: {
            },
            label: {},
            descr: {
                default: false
            },
            show: {
                default: false
            },
            value: {}, 
            reference: {},
            placeholder: {},
            id: {},
            checked: {
                type: Boolean,
                default: false,
            },
            required: {
                type: Boolean,
                default: false
            },
            showError: {
                
            },
            options: {
                default() {
                    return {}
                }
            },
            simplified: {
                default: false,
            },
            validation: {
                default: false
            },
        },
        watch: { 
            show: function(newVal, oldVal) {
                if (newVal == true 
                    && this.type != "checkbox" 
                    && this.type != "radio"
                    && this.type != "select") {
                    // this.$refs.input.querySelector("input, textarea").focus();
                }
            },
            checked(newValue) {
                this.toggle();
            },
            address: {
                handler(val) {
                    if (val && val.position && val.name) {
                        this.$emit('input', val);
                    }
                },
                deep: true,
            },
        },
        
        data () {
            if (this.type == "checkbox" && Object.keys(this.options).length > 0) {
                var myValue = [];
            } else {
                var myValue = "";
            } 
            if (this.value != false && this.value != "") {
                var myValue = this.value;
            }
            return {
                showDescr: false,
                myValue: myValue,
                address: {
                    position: null,
                    name: null,
                },
            };
        },

        computed: {
            validated() {
                var val = this.value;
                if (this.validation) {
                    return this.validation(val);
                } else {
                    return true;
                }
            }
        },

        methods: {
            onChange() {
                this.toggle();
                if (this.type == "radio") {
                    setTimeout(() => {
                        this.$emit('enter');
                    }, 200);
                    
                }
                
            },
            onInput(event) {
                this.$emit('input', event.target.value);
                
            },
            toggle() {
                this.$emit('input', this.myValue);
            },

            enter() {
                if (this.type == 'address') {
                    // only enter if address is in there
                    if (
                        this.address &&
                        this.address.name &&
                        this.address.position
                    ) {
                        this.$emit('enter');
                    }
                } else {
                    this.$emit('enter');
                }
            },

            
        },
        mounted() {
        }
    }

</script>


<style scoped lang='scss'>

$background: $primary-color;
$font-color: white;
$font-color-inverted: black;

.input-page {
    position: absolute;
    width: 100%;
    max-width: 1500px;
    height: 100%;
    top: 0px;
    left: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    padding: 2.5em;
    padding-right: 3.5em;
    overflow: auto;
    z-index: 1;
}

.input-box {
    display: block;
    width: 100%;
    position: relative;
    max-width: 1300px;
    
}

.input-box .h1 {
    position: relative;
    display: flex;
    width: auto;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
    line-height: 1.1;
    padding-bottom: 1.5em;
}

.input-box h1 {
    font-size: 2em;
    display: inline-block;
    width: auto;
    min-width: auto;
    font-weight: bold;
}

.input-wrapper {
    /*display: inline-block;*/
    position: relative;
    line-height: 1;
}


.icon {
    display: inline-block;
    margin: 0;
    line-height: 1.3;
    width: 1.3em;
    min-width: 1.3em;
    text-align: center;
    height: 1.3em;
    min-height: 1.3em;
    font-size: 1em;
    margin-left: 0.5em;
    opacity: 0.4;
    color: $font-color;
    border-radius: 3em;
    border: 2px solid $font-color;
    transition: all 0.3s linear;
    cursor: pointer;
}

.icon:hover {
    opacity: 1;
}

.input,
.textarea,
.checkbox {
    display: inline-block;
    font-size: 4em;
    background-color: transparent;
    border: 0px solid rgba($font-color, 0.3);
    border-bottom-width: 2px;
    border-radius: 0;
    outline: none;
    transition: 0.2s ease;
}

.checkbox {
    border-bottom-width: 0px;
}

.input:focus,
.textarea:focus {
    border-color: rgba($font-color, 1);
}


.input::placeholder,
.textarea::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: rgba($font-color, 0.15);
    opacity: 1; /* Firefox */
    transition: 0.2s ease;
}

.input:-ms-input-placeholder,
.textarea:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: rgba($font-color, 0.15);
    transition: 0.2s ease;
}

.input::-ms-input-placeholder,
.textarea::-ms-input-placeholder { /* Microsoft Edge */
    color: rgba($font-color, 0.15);
    transition: 0.2s ease;
}



.input:focus::placeholder,
.textarea:focus::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: rgba($font-color, 0);
    opacity: 1; /* Firefox */
}

.input:focus:-ms-input-placeholder,
.textarea:focus:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: rgba($font-color, 0);
}

.input:focus::-ms-input-placeholder,
.textarea:focus::-ms-input-placeholder { /* Microsoft Edge */
    color: rgba($font-color, 0);
}

.input,
.textarea {
    font-weight: bold;
    width: calc(100% - 1em);
    max-width: 1000px;
    color: $font-color;
}


.textarea {
    border-width: 2px;
    padding: 0.5em;
    font-size: 1.3em;
    line-height: 1.4;
    height: 5em;
    font-weight: normal;
}

.textarea:focus {
    height: 8em;
}

.description {
    max-width: 650px;
    min-width: 240px;
    padding: 1em;
    display: inline-block;
    font-size: 1em;
    font-weight: normal;
    font-style: italic;
    color: rgba($font-color, 0.6);
    background-color: lighten( $background, 3% );
    box-shadow: 3px 4px 15px rgba(darken( $background, 50% ), 0.1);
    transform: translateX(1em);
    transition: all 0.3s ease;
    pointer-events: none;
    position: absolute;
}

.checkbox {
    display: inline-block;
    font-size: 1.4em;
}

.checkbox input {
    position: absolute;
    pointer-events: none;
    width: 0.1px;
    height: 0.1px;
    z-index: -1;
    opacity: 0;
}

.checkbox .checkbox--wrapper {
    display: inline-block;
    padding: 0.5em 1em;
    margin-right: 0.4em;

    border: 2px solid $font-color;
    opacity: 0.7;
    cursor: pointer;
    color: $font-color;
    transition: all 0.1s ease;
}

.checkbox--wrapper:active {
    transform: translateY(0.1em);
}
.checkbox input:checked ~ .checkbox--wrapper {
    background-color: $font-color;
    color: $background;
}


/* ANIMATIONS */
.fs-descr-enter,
.fs-descr-leave-to {
    opacity: 0;
    transform: translateX(1em) translateY(1em);
}

.fs-descr-enter-active {
    transition: all 0.2s ease;
}


.fs-flow-in-enter,
.fs-flow-in-input-enter {
    opacity: 0;
    transform: translateY(20vh);
}

.fs-flow-in-leave-to,
.fs-flow-in-input-leave-to {
    opacity: 0;
    transform: translateY(-20vh);
}


.fs-flow-in-enter-active {
    transition: all 0.5s 0.3s cubic-bezier(0,0.4,0,1);
}
.fs-flow-in-leave-active {
    transition: all 0.5s cubic-bezier(0,1,0.6,1);
}
.fs-flow-in-input-enter-active {
    transition: all 0.5s 0.5s cubic-bezier(0,0.4,0,1);
}
.fs-flow-in-input-leave-active {
    transition: all 0.5s 0.3s cubic-bezier(0,1,0.6,1);
}

.error-msg {
    position: absolute;
    bottom: calc(100% + 2em);
    left: 0%;
    max-width: 100%;
}

.error-msg h2 {
    width: 100%;
    font-size: 1.5em;
    padding: 0;
    margin: 0;
}

.validation-indicator {
    display: inline-block;
    transition: all 0.4s cubic-bezier(0.8,0,0.2,1);
    border: 0.6em solid transparent;
    border-top-width: 0;
    border-left-width: 0;
    opacity: 0.1;
    height: 3em;
    width: 3em;
    transform: rotate(-45deg);
}

.validation-indicator:after,
.validation-indicator:before {
    transition: inherit;
    position: absolute;
    left: calc(50% - 0.3em);
    width: 0.6em;
    top: 0px;
    content: "";
    height: 100%;
    background-color: $font-color-inverted;
}

.validation-indicator:before {
    transform: rotate(90deg);
}

.validation-indicator.correct {
    top: 0.6em;
    border-color: $font-color-inverted;
    width: 1.5em;
    transform: rotate(45deg); 
}

.validation-indicator.correct:after,
.validation-indicator.correct:before {
    width: 100%;
    opacity: 0;
}

@media (max-width: 900px) {
    .description {
        transform: translateX(-100%) translateX(-1.5em);
    }

    .fs-descr-enter,
    .fs-descr-leave-to {
        opacity: 0;
        transform: translateX(-100%) translateX(-1.5em) translateY(1em);
    }
}

@media (max-width: 650px) {
    .input,
    .textarea,
    .checkbox {
        display: inline-block;
        font-size: 2.6em;
    }

    .input-box h1 {
        font-size: 1.3em;
    }

    .textarea {
        font-size: 1em;
    }

}

@media (max-width: 445px) {
    .input,
    .textarea,
    .checkbox {
        display: inline-block;
        font-size: 1.4em;
    }

    .input-box h1 {
        font-size: 1.3em !important;
    }

    .textarea {
        font-size: 1em;
    }

    .textarea:focus {
        height: 12em;
    }

}


</style>




// WEBPACK FOOTER //
// src/components/fullscreenFormInput.vue